import { TestimonialDetails } from '@/modals/testimonial/testimonial-details';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss']
})
export class TestimonialComponent implements OnInit {

  isModalVisible: boolean = false
  // thumbnail image
  base64Code: string | null = null;
  fileType: string | null = null;
  // api
  destroy$: Subject<boolean> = new Subject<boolean>();
  // testmonialDetails
  testimonialDetails :TestimonialDetails[] =[]
  // max character
  maxCharacter:boolean = false
  // isUpdate
  isUpdate: boolean = false
  // quill
  // Quill toolbar options (exclude image, headers, size)
quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],        // text formatting
    [{ 'color': [] }, { 'background': [] }],         // color dropdown
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],   // lists
    [{ 'align': [] }],                                // alignment
    ['link'],                                        // hyperlink button
    ['clean']                                        // remove formatting
  ]
};



  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private appService: AppService,
    private router: Router,
    protected configService: ConfigService,
  ) { }

  ngOnInit(): void {
    this.getTestimonial()
  }



 addTestimonialForm = new UntypedFormGroup({
  testimonialSeq: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  description: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  testimonialBy: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  title: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  websiteId: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  websiteName: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  base64Code: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  fileType: new UntypedFormControl("", [
    Validators.required,
    Validators.nullValidator,
  ]),
  rating: new UntypedFormControl(0, [
    Validators.required,
    Validators.nullValidator,
  ]),
  filePath: new UntypedFormControl(""),        // optional
  name: new UntypedFormControl(""),            // optional
  createdAt: new UntypedFormControl(0),        // optional, can set during creation
  createdBy: new UntypedFormControl(""),       // optional
  updatedAt: new UntypedFormControl(0),        // optional, can set during edit
  updatedBy: new UntypedFormControl(""),       // optional
  status: new UntypedFormControl("Active"),    // optional, default to active
});



  public testimonialFormErrors = {
    description: "",
    testimonialBy: "",
    title: "",
    base64Code: ""
  }

testimonialFormValidation(): void {
  const form = this.addTestimonialForm;
  let hasError = false;

  // Reset all errors
  Object.keys(this.testimonialFormErrors).forEach(key => this.testimonialFormErrors[key] = '');

  // Description validation
// Get Quill HTML content
const descriptionHtml = form.get('description')?.value || '';

// Convert HTML to plain text
const tempDiv = document.createElement('div');
tempDiv.innerHTML = descriptionHtml;
const descriptionText = tempDiv.textContent || tempDiv.innerText || '';

// Validation
if (!descriptionText.trim()) {
  this.testimonialFormErrors.description = 'Testimonial description is required.';
  form.get('description')?.markAsTouched();
  hasError = true;
} else if (descriptionText.length > 500) {
  this.maxCharacter = true
  this.testimonialFormErrors.description = 'Description cannot exceed 500 characters.';
  form.get('description')?.markAsTouched();
  hasError = true;
}


  // Testimonial By
  if (!form.get('testimonialBy')?.value?.trim()) {
    this.testimonialFormErrors.testimonialBy = 'Testimonial By is required.';
    form.get('testimonialBy')?.markAsTouched();
    hasError = true;
  }

  if (!hasError) {
    this.maxCharacter = false
    form.patchValue({
      websiteId: Number(localStorage.getItem('selectedWebsiteId')),
      websiteName: localStorage.getItem('selectedWebsiteName')
    });
    console.log('Form value', form.value);

    if (this.isUpdate) {
      this.updateTestimonial(form.value);
    } else {
      this.saveTestimonial(form.value);
    }

  }
}

saveTestimonial(formData: any): void {
  this.spinner.show();
  this.appService.addTestimonial(formData)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (data) => {
        console.log('Testimonial saved:', data);
        this.spinner.hide();
        this.toastr.success('Testimonial saved successfully!');
        this.isModalVisible = false;
        this.addTestimonialForm.reset()
        this.getTestimonial()
      },
      error: (error) => {
        console.error('Error:', error);
        this.spinner.hide();
        const msg = error?.error?.msg || 'Something went wrong, please try again';
        this.toastr.error(msg);
      }
    });
}


updateTestimonial(formData: any): void {
  this.spinner.show();
  this.appService.updateTestimonial(formData)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (data) => {
        console.log('Testimonial saved:', data);
        this.spinner.hide();
        this.toastr.success('Testimonial saved successfully!');
        this.isModalVisible = false;
        this.addTestimonialForm.reset()
        this.getTestimonial()
      },
      error: (error) => {
        console.error('Error:', error);
        this.spinner.hide();
        const msg = error?.error?.msg || 'Something went wrong, please try again';
        this.toastr.error(msg);
      }
    });
}


    // thumbnail select
onFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;

  if (input.files && input.files.length > 0) {
    const file = input.files[0];

    // Extract extension (without dot)
    this.fileType = file.name.split('.').pop()?.toLowerCase() || null;

    const reader = new FileReader();
    reader.onload = () => {
      // Base64 string
      this.base64Code = reader.result as string;
      console.log('Base64:', this.base64Code);
      console.log('File Type:', this.fileType);
    };
    reader.readAsDataURL(file); // convert to base64
    this.addTestimonialForm.controls['base64Code'].setValue(this.base64Code);
    this.addTestimonialForm.controls['fileType'].setValue(this.fileType);
  }
}


// get Testimonial
getTestimonial(): void {
  this.spinner.show();
  this.appService.getTestimonial()
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (data) => {
        this.testimonialDetails = data.sort((a,b)=> b.testimonialSeq - a.testimonialSeq)
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Error:', error);
        this.spinner.hide();
        const msg = error?.error?.msg || 'Something went wrong, please try again';
        this.toastr.error(msg);
      }
    });
}

toggleStatus(item: any, event: any) {
     
   if(event.target.checked) {
    const payload = {
      testimonialSeq:item,
      status: 'Active'
    }
     this.updateStatus(payload)
    console.log("checked or Active",payload )
   } else {
     const payload = {
      testimonialSeq:item,
      status: 'InActive'
    }
    this.updateStatus(payload)
    console.log("Un-checked or Inactive",payload )
   }
  }

  updateStatus(payload) {
    this.spinner.show();
    this.appService
      .updateTestimonialStatus(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          console.log("status", data);
          this.spinner.hide()
         this.toastr.success (" Status Updated successfully");
        },
        (error: any) => {
          this.spinner.hide();
          this.toastr.error(
            error.error.message || "Something went wrong,please try again..."
          );
        }
      );
  }


deleteTestimonial(id: number) {
 this.spinner.show();
  this.appService.deleteTestimonial(id)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (data) => {
        this.toastr.success('Testimonial Deleted successfully!');
        this.spinner.hide()
        this.getTestimonial()
      },
      error: (error) => {
        console.error('Error:', error);
        this.spinner.hide();
        const msg = error?.error?.msg || 'Something went wrong, please try again';
        this.toastr.error(msg);
      }
    });
}

editTestimonial(testimonial: any) {
  console.log("update testi", testimonial)
  this.isUpdate = true;

  // Populate the form with all fields from the testimonial object
  this.addTestimonialForm.patchValue({
    testimonialSeq: testimonial.testimonialSeq,
    filePath: testimonial.filePath || '',
    name: testimonial.name || '',
    title: testimonial.title || '',
    description: testimonial.description || '',
    createdAt: testimonial.createdAt || 0,
    createdBy: testimonial.createdBy || '',
    updatedAt: testimonial.updatedAt || 0,
    updatedBy: testimonial.updatedBy || '',
    websiteId: testimonial.websiteId || '',
    websiteName: testimonial.websiteName || '',
    status: 'Active',
    rating: testimonial.rating || 0,
    testimonialBy: testimonial.testimonialBy || '',
    base64Code: testimonial.base64Code || '',
    fileType: testimonial.fileType || ''
  });

  // Show the modal
  this.isModalVisible = true;
}


closeModel() {
  this.isModalVisible = false
  this.addTestimonialForm.reset()
  if(this.isUpdate) {
    this. isUpdate = false
  }
}



}
